/* ===== Kohinoor — Color Card Slideshow (Fade + per-card speed) ===== */
(function(){
  const DEFAULT_MS = 2500;   // fallback if no data-speed set
  const HOVER_PAUSE = true;

  if (window.__colorCardSlideInit) return;
  window.__colorCardSlideInit = true;

  function parseSlides(el){
    return (el.getAttribute('data-slides') || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);
  }
  function getSpeed(el){
    const v = parseInt(el.getAttribute('data-speed'), 10);
    return isFinite(v) && v > 0 ? v : DEFAULT_MS;
  }

  function startCard(card){
    if (card.__slideshow) return;

    const slides = parseSlides(card);
    if (slides.length <= 1) return;

    let idx = 0;
    let img = document.createElement('div');
    let nextImg = document.createElement('div');
    img.className = 'card-img fade-show';
    nextImg.className = 'card-img';
    card.append(img, nextImg);
    img.style.backgroundImage = `url(${slides[0]})`;

    const SPEED = getSpeed(card);

    const swap = () => {
      idx = (idx + 1) % slides.length;
      nextImg.style.backgroundImage = `url(${slides[idx]})`;
      nextImg.classList.add('fade-show');
      img.classList.remove('fade-show');
      [img, nextImg] = [nextImg, img];
    };

    let timer;
    const play = () => { stop(); timer = setInterval(swap, SPEED); };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

    if (HOVER_PAUSE){
      card.addEventListener('mouseenter', stop);
      card.addEventListener('mouseleave', play);
    }

    const vis = () => (document.visibilityState === 'visible') ? play() : stop();
    document.addEventListener('visibilitychange', vis);

    play();
    card.__slideshow = { play, stop };
  }

  function init(){ document.querySelectorAll('.color-card').forEach(startCard); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
